import { API_DOMAIN } from '@constants/app-constants';
import { call, put, takeEvery } from 'redux-saga/effects';
import Actions from '../action';
import Axios from 'axios';


export function* getEmployeeServices(action) {
	let formData = new FormData();
	formData.append('file', action.params);
	try {
		let branchid = localStorage.getItem('branchId');

		const uri = `${API_DOMAIN}/Employee/${branchid}/upload`;
		let res = yield call(Axios.post, uri, formData);

		yield put(Actions.creators.postuploadSuccess(res.data));
	} catch (err) {
		// message.error(err)
		yield put(Actions.creators.postuploadError());
	}
}
export function* getEmployeeData(action) {
	try {
		let branchid = localStorage.getItem('branchId');

		// let branchid = 33304;
		const uri = `${API_DOMAIN}/Employee/${branchid}?pageNumber=${action.res.pageNumber}&pageSize=${action.res.pageSize}`;
		let res = yield call(Axios.get, uri);

		yield put(Actions.creators.getemployeeSuccess(res.data));
	} catch (err) {
		// message.error(err)
		yield put(Actions.creators.postemployeeError());
	}
}

export function* postEmployeeAdd({ params, requestParams, isAdd, etype }) {
	try {
		let branchId = localStorage.getItem('branchId');

		const uri = `${API_DOMAIN}/Employee/${branchId}/save`;
		let res = yield call(Axios.patch, uri, params);
		if (etype === 'orderCards') {
			yield put(Actions.creators.postemployeeSuccess(res.data));
		}
		if (etype === 'orderCards' && !res.data) {
			yield put(Actions.creators.getordercardStart());
		}
	} catch (err) {
		// message.error(err)
		yield put(Actions.creators.postuploadSuccess());
	}
}
export function* getNationalData(action) {
	try {
		// let branchid = 33304;
		const uri = `${API_DOMAIN}/Country`;
		let res = yield call(Axios.get, uri);

		yield put(Actions.creators.getnationalSuccess(res.data));
	} catch (err) {
		// message.error(err)
		yield put(Actions.creators.postemployeeError());
	}
}
export function* delEmployeeData(action) {
	try {
		let branchid = localStorage.getItem('branchId');

		// let branchid = 33304;

		const uri = `${API_DOMAIN}/Employee/${branchid}/${action.res}`;
		let res = yield call(Axios.delete, uri);

		yield put(Actions.creators.getemployeeStart(action.requestParams));
	} catch (err) {
		// message.error(err)
		yield put(Actions.creators.postemployeeError());
	}
}
export function* getBankNameData(action) {
	try {
		// let branchid = 33304;
		const uri = `${API_DOMAIN}/Routing`;
		let res = yield call(Axios.get, uri);

		yield put(Actions.creators.getbanknameSuccess(res.data));
	} catch (err) {
		// message.error(err)
		yield put(Actions.creators.postemployeeError());
	}
}
export function* ordercardDataSaga(action) {
	try {
		// let branchid = 33304;
		let branchid = localStorage.getItem('branchId');
		const uri = `${API_DOMAIN}/Employee/${branchid}/order-card`;
		let res = yield call(Axios.get, uri);

		yield put(Actions.creators.getordercardSuccess(res.data));
		console.log('res', res.data);
	} catch (err) {
		// message.error(err)
		yield put(Actions.creators.postemployeeError());
	}
}

export function* salarytemplate(action) {
	try {
		// let branchid = 33304;
		let branchid = localStorage.getItem('branchId');
		const uri = `${API_DOMAIN}/FileTemplate/Employee/Download`;
		let res = yield call(Axios.get, uri, {
			responseType: 'blob',
			headers: {
				Accept: 'application/pdf',
			},
		});

		// yield put(Actions.creators.getordercardSuccess(res.data));
		const downloadUrl = window.URL.createObjectURL(res.data);
		const link = document.createElement('a');
		link.href = downloadUrl;
		link.setAttribute('download', 'Employee.xls');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	} catch (err) {
		// message.error(err)
		yield put(Actions.creators.postemployeeError());
	}
}

export default function* orderWatcher() {
	yield takeEvery(Actions.types.POST_UPLOAD_DATA_START, getEmployeeServices);
	yield takeEvery(Actions.types.POST_ADD_EMPLOYEE_START, postEmployeeAdd);
	yield takeEvery(Actions.types.GET_EMPLOYEE_DATA_START, getEmployeeData);
	yield takeEvery(Actions.types.GET_NATIONAL_DATA_START, getNationalData);
	yield takeEvery(Actions.types.DEL_EMPLOYEE_DATA_START, delEmployeeData);
	yield takeEvery(Actions.types.GET_NATIONAL_DATA_START, getBankNameData);
	yield takeEvery(Actions.types.GET_ORDER_CARD_START, ordercardDataSaga);
	yield takeEvery(Actions.types.GET_SALARY_TEMPLATE_START, salarytemplate);
}
